import React from "react";
import { createRoot } from "react-dom/client";
import TiptapEditor from "../../components/TiptapEditor";

const roots = new Map();

function mountAll() {
  document.querySelectorAll("[data-tiptap-editor]").forEach((el) => {
    // Skip if already mounted
    if (roots.has(el)) return;

    const inputId = el.dataset.inputId;
    const label = el.dataset.label || "";
    const toolbar = el.dataset.toolbar || "full";
    const wordCounterMax = el.dataset.wordCounterMax
      ? parseInt(el.dataset.wordCounterMax, 10)
      : undefined;
    const imageUploadUrl = el.dataset.imageUploadUrl || "/admin/image_upload";

    const root = createRoot(el);
    root.render(
      React.createElement(TiptapEditor, {
        inputId,
        label,
        toolbar,
        wordCounterMax,
        imageUploadUrl,
      })
    );
    roots.set(el, root);
  });
}

function unmountAll() {
  roots.forEach((root, el) => {
    root.unmount();
  });
  roots.clear();
}

document.addEventListener("turbolinks:load", mountAll);
document.addEventListener("turbolinks:before-cache", unmountAll);
